import React, { Component } from 'react';
import {
	IOverlayProps,
	IOverlayState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import BioText from './styledComponents/BioText';
import OverlayCard from './styledComponents/OverlayCard';
import OpenButton from './styledComponents/OpenButton';
import CloseButton from './styledComponents/CloseButton';
import Grid from '@kurtosys/ksys-app-components/dist/components/base/Grid';

@inject('appStore', 'overlayStore')
@observer
export class Overlay extends Component<IOverlayProps, IOverlayState> {
	static configurationKey: 'overlay' = 'overlay';
	static styleKey: 'overlay' = 'overlay';
	constructor(props: IOverlayProps) {
		super(props);

		this.state = { show: false };
	}

	CloseOverlay = () => {
		this.setState({ show: false });
	}

	OpenOverlay = () => {
		this.setState({ show: true });
	}

	render() {
		const { className, overlayStore } = this.props;

		if (!overlayStore) {
			return null;
		}

		const { cardProps, bioProps, closeButtonProps, openButtonProps, gridProps, components } = overlayStore;

		if (closeButtonProps) {
			closeButtonProps.onClick = this.CloseOverlay;
		}

		if (openButtonProps) {
			openButtonProps.onClick = this.OpenOverlay;
		}

		if (bioProps && bioProps.value) {
			return (
				<Wrapper data-selector="fund-managers-overlay-wrapper" className={ className }>
					<OpenButton { ...openButtonProps } />
					{ this.state.show &&
						<OverlayCard { ...cardProps }>
							<CloseButton { ...closeButtonProps } />
							{ gridProps ?
								<Grid components={ components } { ...gridProps } /> :
								<BioText { ...bioProps } /> }
						</OverlayCard>
					}
				</Wrapper>
			);
		}

		return null;
	}
}

export default InjectedStyledComponent(Overlay, 'overlay');